export const LANDLORD_AUTH_SUCCESS = 'LANDLORD_AUTH_SUCCESS'
export const LANDLORD_AUTH_LOGOUT = 'LANDLORD_AUTH_LOGOUT'
export const LANDLORD_AUTH_ERROR = 'LANDLORD_AUTH_ERROR'
export const LANDLORD_SET_ADMIN = 'LANDLORD_SET_ADMIN'
